<template>
  <div>
    <b-table
      responsive
      hover
      selectable
      selectedVariant="transparent"
      :current-page="currentPage"
      :items="filteredTableData"
      :per-page="11"
      :fields="fields"
      @sort-changed="sortChange"
      @row-clicked="select"
      id="portfolio-table-1"
    >
      <template slot=" " slot-scope="data">
        <img class="select-icon pt-2" :src="selectIcon(data.item)" alt="select button icon" />
      </template>
      <template slot="symbol" slot-scope="data">
        <div class="stock-symbol text-truncate text-left">
          {{data.item.symbol}}
          <notification-icon :stock="data.item"></notification-icon>
        </div>
        <div class="stock-name text-truncate text-left">{{data.item.name}}</div>
      </template>
      <template slot="stop" slot-scope="data">
        <div class="pt-2 text-right">{{ data.item.stop | getPercentage }}</div>
      </template>
      <template slot="recommendation" slot-scope="data">
        <div class="pt-2 text-right">{{ data.item.recommendation | recommendationStatus }}</div>
      </template>
      <template slot="buy" slot-scope="data">
        <div class="pt-2 text-right">{{ data.item.buy | rounding(data.item.currencysign) }}</div>
      </template>
      <template slot="last" slot-scope="data">
        <div class="pt-2 text-right">{{ data.item.last | rounding(data.item.currencysign) }}</div>
      </template>
      <template slot="change" slot-scope="data">
        <div
          class="pt-2 text-right"
          v-bind:class="getStockChange(data.item.change)"
        >{{ formatChange(data.item.change) | getPercentage}}</div>
      </template>
    </b-table>
    <b-row class="pt-4">
      <b-col>
        <b-pagination
          class="tbl-pagination"
          v-model="currentPage"
          :total-rows="filteredTableDataLength"
          :per-page="perPage"
          limit="3"
          fixed="true"
          first-text="« First"
          prev-text="‹ Prev"
          next-text="Next ›"
          last-text="Last »"
          @change="paginate"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import NotificationIcon from '@/components/NotificationIcon'
export default {
  components: {
    NotificationIcon
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    fields: Array,
    select: Function
  },
  data () {
    return {
      currentPage: 1,
      totalRows: this.tableData.length,
      perPage: 11
    }
  },
  filters: {
    getPercentage: percentage => (percentage === 0 ? '0%' : `${percentage.toFixed(2)}%`),
    rounding: (value, currencySymbol) => (value === 0 ? '' : `${currencySymbol} ${value.toFixed(2)}`),
    recommendationStatus: status => {
      const STATUS_CODE = {
        '10': 'Buy',
        '20': 'Buy Cover',
        '30': 'To Close',
        '35': 'Buy To Open',
        '40': 'Hold',
        '50': 'Hold Short',
        '60': 'Sell',
        '70': 'Sell Short',
        '80': 'Sell To Open',
        '90': 'Reduce',
        '100': 'Sell Put'
      }

      return STATUS_CODE[status]
    }
  },
  methods: {
    paginate: page => {},
    sortChange (ctx) {
      // tracking stock legend click event
      this.$ea.trackEvent({
        type: 'stock_sort',
        value: { sort_by: ctx.sortBy, order: ctx.sortDesc ? 'desc' : 'asc' }
      })
    },
    selectIcon: stock => {
      const img = stock.selected ? 'select-star-active.svg' : 'select-star.svg'
      return require(`@/assets/images/portfolio-tracker/${img}`)
    },
    getStockChange: change => {
      if (change === 0) return 'change-even'
      return change > 0 ? 'change-up' : 'change-down'
    },
    formatChange: change => {
      return (change * 100)
    }
  },
  computed: {
    filteredTableData: function () {
      return this.tableData.filter(item => item.status !== 2)
    },
    filteredTableDataLength: function () {
      return this.filteredTableData.length
    }
  }
}
</script>
<style lang="scss" scoped>
.stock-symbol {
  display: block;
  font-weight: bold;
  color: $color-text-grey;
  max-width: 5rem;
}
.stock-name {
  max-width: 5rem;
  font-size: 0.9rem;
  color: $color-text-grey;
}
.select-stock {
  background: url('../assets/images/portfolio-tracker/select-star.svg');
  &:hover {
    display: none;
    .select-stock-active {
      display: inline;
    }
  }
}
.select-icon {
  width: 2rem;
}
.select-stock-active {
  display: none;
}
.change-even {
  color: $color-text-grey;
}
.change-up {
  color: $color-stock-indicator-increase;
}
.change-down {
  color: $color-stock-indicator-decrease;
}
</style>
